import { ProductHeading, ProductParagraph } from '@issuu/silkscreen';
import React, { memo, useEffect, useState } from 'react';
import styled from 'styled-components';
import { StoryContent } from '../Story';
const HeaderElement = styled.div `
    position: relative;
    background: linear-gradient(to top, #000000 0%, transparent 50%);
    color: white;
    display: flex;
    max-width: 720px;
    aspect-ratio: ${props => props.ratio};
    left: 0;
    right: 0;
    margin: auto;
    flex-direction: column;
    &::before {
        opacity: ${props => (props.isImageLoaded ? 1 : 0)};
        transition: opacity 250ms ease-in-out;
        background-color: #777;
        background-image: url('${props => props.imageSrc}');
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        z-index: -1;
    }
`;
const HeaderPadding = styled.div `
    height: 0;
    padding-bottom: ${props => 100 / props.ratio}%;
`;
const Content = styled(StoryContent) `
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    flex: 1;
    width: 100%;
    padding: 0 1em 2em 1em;
    position: absolute;
    bottom: 0;
    @media (min-width: 720px) {
        padding: 0 2.25em 2em 2.25em;
    }
`;
const Header = (props) => {
    const { bgImageSrc, title, readTimeMinutes, onChange, CustomHeader, ratio = 4 / 3 } = props;
    const [imageLoaded, setImageLoaded] = useState(false);
    useEffect(() => {
        const image = new Image();
        image.onload = () => setImageLoaded(true);
        image.src = bgImageSrc;
        if (image.complete) {
            setImageLoaded(true);
        }
    }, []);
    return (React.createElement(HeaderElement, { imageSrc: bgImageSrc, isImageLoaded: imageLoaded, itemProp: "image", ratio: ratio },
        React.createElement(HeaderPadding, { ratio: ratio }),
        React.createElement(Content, null,
            React.createElement(ProductParagraph, { step: "negative-1", style: { textTransform: 'uppercase', letterSpacing: '2px' } },
                readTimeMinutes || 1,
                " minute read"),
            CustomHeader ? (React.createElement(CustomHeader, { itemProp: "headline", onChange: onChange, value: title })) : (React.createElement(ProductHeading, { itemProp: "headline", style: { letterSpacing: '1px' } }, title)))));
};
export default memo(Header);
//# sourceMappingURL=Header.js.map